import { axiosService } from './axiosService';

const auth = () => axiosService.setAuth(true);

const unwrap = async (req: Promise<any>) => {
  try {
    const { data } = await req;
    return { ok: true, data: data?.data ?? data, raw: data };
  } catch (error: any) {
    const message =
      (error?.response?.data?.message) || error?.message || 'Request failed';
    return { ok: false, error: message };
  }
};

export type WithdrawalStatus = 'requested' | 'processing' | 'paid' | 'failed';

export const withdrawalService = {
  list: (status: string, page = 1, limit = 20) =>
    unwrap(auth().get(`user/admin/withdrawals?status=${status || ''}&page=${page}&limit=${limit}`)),
  approve: (id: string) => unwrap(auth().patch(`user/admin/withdrawals/${id}/approve`)),
  reject: (id: string, reason: string) =>
    unwrap(auth().patch(`user/admin/withdrawals/${id}/reject`, { reason })),
};
